const transformDomain = (url: URL): string => url.hostname.split(".").slice(-2).join(".");
export default transformDomain;
